// Collection of UI utilites
import jQuery from 'jquery';
import _ from 'lodash';

if (!Mobi2Go.UI.helpers) Mobi2Go.UI.helpers = {};

/**-------------------------------------------------------------------------
 */
Mobi2Go.UI.helpers.spinner = function($el, status) {
    if (status) {
        $el.html(
            '<div class="m2g-icon m2g-icon--large m2g-icon--spinner m2g-loader"></div>'
        );
    } else {
        $el.html('');
    }
};

/**-------------------------------------------------------------------------
 * Scroll Utility
 */
const $body = jQuery('html, body');
const $window = jQuery(window);
Mobi2Go.UI.helpers.scrollTo = function(
    selector,
    callback,
    force_scroll,
    margin
) {
    const $el = jQuery(selector);

    if (!$el.length) {
        return;
    }

    const window_height =
        $window.height() - Mobi2Go.UI.global_page_scroll_offset;
    const scrolltop = $window.scrollTop();
    let element_scrolltop = $el.offset().top;
    const duration = 240;

    margin = +margin || 0;
    margin -= Mobi2Go.UI.global_page_scroll_offset;

    if (_.isNumber(margin)) {
        element_scrolltop += margin;
    }

    element_scrolltop += Mobi2Go.UI.helpers.scrollTo.offset;

    // element is already in the window viewport - do not bother scrolling
    if (
        scrolltop < element_scrolltop &&
        window_height + scrolltop > element_scrolltop &&
        !force_scroll
    ) {
        _.isFunction(callback) && callback();
        return;
    }
    if (Mobi2Go.app.disable_animation) {
        $body.scrollTop(element_scrolltop);
    } else {
        $body.animate({ scrollTop: element_scrolltop });
    }

    // Delay - jQuery callback fires twice :'o?
    _.isFunction(callback) && _.delay(callback, duration);
};

Mobi2Go.UI.helpers.scrollTo.offset = 0;

/**-------------------------------------------------------------------------
 * Animation helper
 */
const animation_events = [
    'webkitAnimationEnd',
    'oAnimationEnd',
    'msAnimationEnd',
    'animationend',
].join(' ');

Mobi2Go.UI.helpers.setAnimation = function(
    element,
    animation,
    remove_on_complete,
    callback
) {
    const $element = jQuery(element);

    element.style.webkitAnimationName = element.style.MozAnimationName = '';

    _.defer(function() {
        element.style.webkitAnimationName = element.style.MozAnimationName = animation;

        // Attach onComplete function to animation end event on page element
        if (remove_on_complete || _.isFunction(callback)) {
            $element.bind(animation_events, onComplete);
        }
    });

    function onComplete() {
        // Reset event listener
        _.isFunction(callback) && callback();
        if (remove_on_complete) {
            // Reset animation on complete
            element.style.webkitAnimationName = '';
            element.style.MozAnimationName = '';
        }
        $element.unbind(animation_events, onComplete);
    }
};

Mobi2Go.UI.helpers.parseColour = function(colour) {
    if (!colour) {
        return null;
    }
    var r, b, g, a;

    if (colour.match(/^rgb/)) {
        var values = colour.match(
            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );
        r = values[1];
        g = values[2];
        b = values[3];
        a = values[4] !== undefined ? parseFloat(values[4]) : 1.0;
    } else {
        var value = +(
            '0x' + colour.slice(1).replace(colour.length < 5 && /./g, '$&$&')
        );
        r = value >> 16;
        g = (value >> 8) & 255;
        b = value & 255;
        a = 1.0;
    }
    return {
        r: r,
        g: g,
        b: b,
        a: a,
    };
};

Mobi2Go.UI.helpers.getBackgroundColor = function(element) {
    if (!element) {
        return null;
    }

    var colour = window.getComputedStyle(element).backgroundColor;
    if (!colour) {
        return null;
    }

    var parsedColour = Mobi2Go.UI.helpers.parseColour(colour);
    if (!parsedColour) {
        return null;
    }

    if (parsedColour.a != 1) {
        var backgroundColorOfParent = Mobi2Go.UI.helpers.getBackgroundColor(
            element.parentElement
        );
        if (!backgroundColorOfParent) {
            return parsedColour;
        }

        return {
            r: Math.floor(
                parsedColour.r * parsedColour.a +
                    backgroundColorOfParent.r * (1.0 - parsedColour.a)
            ),
            g: Math.floor(
                parsedColour.g * parsedColour.a +
                    backgroundColorOfParent.g * (1.0 - parsedColour.a)
            ),
            b: Math.floor(
                parsedColour.b * parsedColour.a +
                    backgroundColorOfParent.b * (1.0 - parsedColour.a)
            ),
            a: 1.0,
        };
    }

    return parsedColour;
};

Mobi2Go.UI.helpers.isElementBackgroundDark = function(element) {
    var colour = Mobi2Go.UI.helpers.getBackgroundColor(element);
    if (!colour) {
        return null;
    }

    var hsp = Math.sqrt(
        0.299 * (colour.r * colour.r) +
            0.587 * (colour.g * colour.g) +
            0.114 * (colour.b * colour.b)
    );

    if (hsp > 127.5) {
        return false;
    } else {
        return true;
    }
};

Mobi2Go.UI.helpers.isColourDark = function(colour) {
    let r;
    let b;
    let g;
    let hsp;
    let a = colour;

    if (a.match(/^rgb/)) {
        a = a.match(
            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );
        r = a[1];
        g = a[2];
        b = a[3];
    } else {
        a = +`0x${a.slice(1).replace(a.length < 5 && /./g, '$&$&')}`;
        r = a >> 16;
        g = (a >> 8) & 255;
        b = a & 255;
    }
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    if (hsp > 127.5) {
        return false;
    }
    return true;
};

/**-------------------------------------------------------------------------
 * Highlight class helper
 */
Mobi2Go.UI.helpers.highlightElement = function($element) {
    if (Mobi2Go.app.disable_animation) {
        return;
    }
    $element = jQuery($element);
    $element.addClass('m2g-highlighted');
    clearTimeout($element.__highlight_timeout);
    $element.__highlight_timeout = setTimeout(function() {
        $element.removeClass('m2g-highlighted');
    }, 3600);
};

/**-------------------------------------------------------------------------
 * Page offset
 */
Mobi2Go.UI.helpers.getPageYOffset = function() {
    return window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
          ).scrollTop;
};

/**-----------------------------------------------------------------------------
 * requestAnimationFrame polyfill
 */
(function() {
    let lastTime = 0;
    const vendors = ['webkit', 'moz'];
    for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame =
            window[`${vendors[x]}RequestAnimationFrame`];
        window.cancelAnimationFrame =
            window[`${vendors[x]}CancelAnimationFrame`] ||
            window[`${vendors[x]}CancelRequestAnimationFrame`];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            const currTime = new Date().getTime();
            const timeToCall = Math.max(0, 16 - (currTime - lastTime));
            const id = window.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
})();

/**-----------------------------------------------------------------------------
 * requestAnimationFrame polyfill
 */
if (!Element.prototype.scrollIntoViewIfNeeded) {
    Element.prototype.scrollIntoViewIfNeeded = function(centerIfNeeded) {
        centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;

        const parent = this.parentNode;
        const parentComputedStyle = window.getComputedStyle(parent, null);
        const parentBorderTopWidth = parseInt(
            parentComputedStyle.getPropertyValue('border-top-width')
        );
        const parentBorderLeftWidth = parseInt(
            parentComputedStyle.getPropertyValue('border-left-width')
        );
        const overTop = this.offsetTop - parent.offsetTop < parent.scrollTop;
        const overBottom =
            this.offsetTop -
                parent.offsetTop +
                this.clientHeight -
                parentBorderTopWidth >
            parent.scrollTop + parent.clientHeight;
        const overLeft =
            this.offsetLeft - parent.offsetLeft < parent.scrollLeft;
        const overRight =
            this.offsetLeft -
                parent.offsetLeft +
                this.clientWidth -
                parentBorderLeftWidth >
            parent.scrollLeft + parent.clientWidth;
        const alignWithTop = overTop && !overBottom;

        if ((overTop || overBottom) && centerIfNeeded) {
            parent.scrollTop =
                this.offsetTop -
                parent.offsetTop -
                parent.clientHeight / 2 -
                parentBorderTopWidth +
                this.clientHeight / 2;
        }

        if ((overLeft || overRight) && centerIfNeeded) {
            parent.scrollLeft =
                this.offsetLeft -
                parent.offsetLeft -
                parent.clientWidth / 2 -
                parentBorderLeftWidth +
                this.clientWidth / 2;
        }

        if (
            (overTop || overBottom || overLeft || overRight) &&
            !centerIfNeeded
        ) {
            this.scrollIntoView(alignWithTop);
        }
    };
}
